// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/8eff79623b934ada1f37.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3316f6b57ed1a091f910","131":"a854df872c0e6996db9d","132":"35d80b12586cea0de38c"}[chunkId] + ".chunk.js";
};